import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';

// import img1 from '../assets/saclib.jpg';
// import img2 from '../assets/download.jpeg';
// import img3 from '../assets/olmec.jpg';
// import img4 from '../assets/Our-Work_Project-Portfolio_J-Paul-Leonard-and-Sutro-Libraries_Hero-Image-1280x582.jpg';
import Grid from '@material-ui/core/Grid';
// import img5 from '../assets/photo-1524995997946-a1c2e315a42f.jpeg';
// import { Toolbar } from "@material-ui/core";
// import ButtonBase from '@material-ui/core/ButtonBase';
// import Paper from '@material-ui/core/Paper';
// import Divider from '@material-ui/core/Divider';
import { connect } from "react-redux";
import { compose } from "redux";
import Modal from '@material-ui/core/Modal';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import TextField from '@material-ui/core/TextField';
import RadioButtonGroup from '@material-ui/core/RadioGroup';
import RadioButton from '@material-ui/core/Radio';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Badge from '@material-ui/core/Badge';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import Phone from "@material-ui/icons/Phone";
// import FavoriteIcon from '@material-ui/icons/Favorite';
// import ShareIcon from '@material-ui/icons/Share';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Calendar from "./Calendar";
// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemText from '@material-ui/core/ListItemText';
// import Avatar from '@material-ui/core/Avatar';
// import ImageIcon from '@material-ui/icons/Image';
// import WorkIcon from '@material-ui/icons/Work';
// import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import { fetchLibrary, updateLibrary } from '../actions/LibraryAction';
import { bookingTimeSlot, getbookingTimeSlot, UpdateBookingTimeSlot } from '../actions/BookingTimeSlotAction';
import { getBookedTime, teamBookingUpdate } from '../actions/BookedAction';
import NewLibraryRequest from "./NewLibraryRequest"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
// import NavigationIcon from '@material-ui/icons/DoneOutline';
// import CloseOutline from '@material-ui/icons/CloseOutlined';
// import Tooltip from '@material-ui/core/Tooltip';
// import Add from '@material-ui/icons/Add';
import { Chip, Toolbar } from "@material-ui/core";
// import BorderColor from '@material-ui/icons/BorderColor';
// import BorderColor from '@material-ui/icons/Edit';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { ATTACHMENT_END_POINT } from "../helpers/constants";
import notfound from '../assets/notfound.png';
import Link from '@material-ui/core/Link';
import _ from 'underscore';
import { TimePicker } from 'material-ui-pickers';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const CustomTableCell = withStyles(theme => ({
    head: {
        // backgroundColor: "#6128be",
        // color: theme.palette.common.white,
        padding: '0px',
        color: "#2926ac",
        fontWeight: "bold",
        fontSize: 13.
    },
    body: {
        padding: '3px',
        fontSize: 14,
        wordBreak:"break-all"
    },
}))(TableCell);


const { innerWidth, innerHeight } = window;


const styles = theme => ({
    card: {
        // maxWidth: 345,
        // wordBreak:"break-all"
    },
    input: {
        display: 'none',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: 'cover',
        height: 250,
        paddingTop: '56.25%', // 16:9
    },
    root: {
        flexGrow: 1,
    },
    // paper: {
    // padding: theme.spacing.unit * 2,
    // textAlign: 'center',
    // color: theme.palette.text.secondary,
    // },
    paper: {
        padding: theme.spacing.unit * 2,
        margin: 20,
        //maxWidth: 1000,
    },
    image: {
        width: '100%',
        height: '100%',
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    grow: {
        flexGrow: 1,
    },
    fontOptions: {
        lineHeight: 1.8,
    },
    centerText: {
        textAlign: 'center'
    },
    headerTextColor: {
        color: '#1E1759',
        fontWeight: 'bold',
        lineHeight: 1.8,
    },
    paragraphTextColor: {
        color: '#888',
        fontWeight: 300,
        fontSize: 15
    },
    table: {
        // minWidth: 800,

        // marginTop: 50
    },
    button: {
        margin: 5,
    },
    // row: {
    //     '&:nth-of-type(odd)': {
    //         backgroundColor: theme.palette.background.default,
    //     },
    // },
    // gradientButton: {
    // // background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)'
    // // background: '#6128be'
    // // background: '#86C42B'
    // background: 'green',
    // '&:focus': {
    // background: 'green'
    // },
    // '&:hover': {
    // background: '#27ad67'
    // },
    // '&:active': {
    // background: '#27ad67'
    // }
    // },
    gradientButton: {
        // background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)'
        // background: '#6128be'
        // background: '#86C42B'
        marginTop: 19,
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },
    buttons: {
        background: 'green',
        color: 'white'
    },
    papers: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 130 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5,
        maxHeight: innerHeight - (theme.spacing.unit * 2),
        // overflow: 'auto' 
    },
    margin: {
        margin: theme.spacing.unit,
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'
    },

    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },
    button1: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        // width: 245,
        // marginTop: -8,
        // marginLeft: 8
        margin:2
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    inputStyled: {
        padding: '13px 1px',
        fontSize: 14,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    inputStyles: {
        padding: '5px 1px',
        fontSize: 14,
        color: 'rgba(0, 0, 0, 0.87)',
    },
    labelRoot: {
        fontSize: '1.3rem'
    },
    textFields: {
        // width: 560,
        // marginTop: -8,
        // marginLeft: 8
        margin:0
    },
    // card: {
    //     maxWidth: 400,
    // },
    // media: {
    //     height: 0,
    //     paddingTop: '56.25%', // 16:9
    // },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    tabsRoot: {
        borderBottom: '1px solid #e8e8e8',
    },
    tabsIndicator: {
        backgroundColor: '#1890ff',
    },
    tabRoot: {
        textTransform: 'initial',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        // marginRight: theme.spacing.unit * 1,
        '&:hover': {
            color: '#40a9ff',
            opacity: 1,
        },
        '&$tabSelected': {
            color: '#1890ff',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: '#40a9ff',
        },
    },
    tabSelected: {},
    typography: {
        padding: theme.spacing.unit * 3,
    },
    paperFortimeSlot: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 50 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5
        // borederTop: "5px solid red"
        // borderBottom: '3px solid blue',
        // borderBottom: '5px solid red' 
    },
    textFieldTime: {
        // width: 150,
        marginTop: -8,
        // marginLeft: 8
    },
    formControl: {
        margin: 0,
        // width: innerWidth >= 480 ? 340 : (innerWidth - (theme.spacing.unit * 2)),
    },
    withOverFlow: {
        overflow: innerWidth > 480 ? 'none' : "auto",
        maxHeight: innerHeight -  (theme.spacing.unit * 8)
    }
});

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}
const Day = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]

class Library extends Component {
    constructor() {
        super();
        this.state = {
            open: false,
            library_name: "",
            library_primary_contact_name: "",
            library_primary_contact_email: "",
            selected_library_image_name: "",
            library_phone: "",
            library_email: "",
            library_image: "",
            website_url: "",
            interested_in_stem: null,
            state_or_county: "",
            city: "",
            state: "",
            country: "",
            zipcode: "",
            address_line1: "",
            address_line2: "",
            notes: "",
            selectedTab: 0,
            myLibrary: {},
            bookingTimeSlot: [],
            user: {},
            timeSlot: false,
            day_of_week: '',
            start_time: null,
            end_time: null,
            library_id: null,
            status: "",
            mode: "ADD",
            id: null,
            start_time_change: null,
            zipcode_error:false
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.myLibrary !== props.myLibrary || state.bookingTimeSlot !== props.bookingTimeSlot) {
            return {
                myLibrary: props.myLibrary,
                bookingTimeSlot: props.bookingTimeSlot,
                library_id: props.user.parent_ref !== undefined ? props.user.parent_ref : null
            }
        }
        return null;
    };

    componentDidMount() {
        this.props.dispatch(fetchLibrary());
        this.props.dispatch(getbookingTimeSlot());
        this.props.dispatch(getBookedTime())
    };

    handleOpen = () => {
        this.setState({
            open: true,
            library_name: this.props.myLibrary[0].library_name !== "null" ? this.props.myLibrary[0].library_name : "",
            library_phone: this.props.myLibrary[0].library_phone !== "null" ? this.props.myLibrary[0].library_phone : "",
            library_email: this.props.myLibrary[0].library_email !== "null" ? this.props.myLibrary[0].library_email : "",
            website_url: this.props.myLibrary[0].website_url !== "null" ? this.props.myLibrary[0].website_url : "",
            interested_in_stem: this.props.myLibrary[0].interested_in_stem !== "null" ? this.props.myLibrary[0].interested_in_stem : "",
            state_or_county: this.props.myLibrary[0].state_or_county !== "null" ? this.props.myLibrary[0].state_or_county : "",
            city: this.props.myLibrary[0].city !== "null" ? this.props.myLibrary[0].city : "",
            state: this.props.myLibrary[0].state !== "null" ? this.props.myLibrary[0].state : "",
            country: this.props.myLibrary[0].country !== "null" ? this.props.myLibrary[0].country : "",
            zipcode: this.props.myLibrary[0].zipcode !== "null" ? this.props.myLibrary[0].zipcode : "",
            address_line1: this.props.myLibrary[0].address_line1 !== "null" ? this.props.myLibrary[0].address_line1 : "",
            address_line2: this.props.myLibrary[0].address_line2 !== "null" ? this.props.myLibrary[0].address_line2 : "",
            notes: this.props.myLibrary[0].notes !== "null" ? this.props.myLibrary[0].notes : ""
        });
    };
    validateZipcode(zipcode) {
        var re = /^([A-Za-z]{2}\s\d{5})$|^(\d{5})$|^([a-zA-Z]{2}-\d{5})$/
		return re.test(zipcode);
     }

    buttonchange = () => {
        //alert(JSON.stringify(this.state))
        let isError = false;
        if (this.state.library_name === "") {
            this.setState({ library_name_error: true })
            isError = true
        }
        if(this.state.library_phone !== ""){
            if (this.state.library_phone.length >= 10 ) {
                if (!this.validatePhone(this.state.library_phone) === true) {
                this.setState({ library_phone_error: true });
                isError = true
            }
            }
            else {
                this.setState({ library_phone_error: true });
                isError = true  
            }
        }
        // if(this.state.zipcode !== ""){
           
		// 	if (this.state.zipcode.length >=5 ) {
        //         if (!this.validateZipcode(this.state.zipcode) === true) {
        //         this.setState({ zipcode_error: true });
        //         isError = true
        //     }
        //     }
        //     else {
        //         this.setState({ zipcode_error: true });
        //         isError = true  
        //     }
        // }
        
        if (this.state.interested_in_stem === null) {
            this.setState({ interested_in_stem_error: true })
            isError = true
        }
        // if (this.state.library_email === "") {
        //     this.setState({ library_email_error: true })
        //     isError = true
        // }

        if (this.state.website_url !== null && this.state.website_url !== "") {
            if (!this.validateUrl(this.state.website_url) === true) {
                this.setState({ invaild_website_url: true })
                isError = true
            }
        }
        // if(this.state.zipcode !== ""){
           
		// 	if (this.state.zipcode.length >=5 ) {
        //         // if (!this.validateZipcode(this.state.zipcode) === true) {
        //         this.setState({ zipcode_error: true });
        //         isError = true
        //     // }
        //     }
        //     else {
        //         this.setState({ zipcode_error: true });
        //         isError = true  
        //     }
        // }
        // if(this.state.zipcode !== ""){
           
		// 	if (this.state.zipcode.length < 5 ) {
        //         // if (!this.validateZipcode(this.state.zipcode) === true) {
        //         this.setState({ zipcode_error: true });
        //         isError = true
        //     // }
        //     }
           
        // }


        // if (this.state.library_email !== null && this.state.library_email !== "") {
        //     if (!this.validateEmail(this.state.library_email) === true) {
        //         this.setState({ invaild_library_email_error: true })
        //         isError = true
        //     }
        // } else {
        //     isError = true
        //     this.setState({ library_email_error: true })

        // }
        if (isError === false) {
            // alert(JSON.stringify(this.state));
            this.props.dispatch(updateLibrary(this, this.state, this.state.myLibrary[0].id))
            this.setState({
                open: false,
                library_name: "",
                library_primary_contact_name: "",
                library_primary_contact_email: "",
                library_phone: "",
                library_email: "",
                website_url: "",
                interested_in_stem: null,
                state_or_county: "",
                library_name_error: false,
                library_primary_contact_name_error: false,
                library_primary_contact_email_error: false,
                library_email_error: false,
                interested_in_stem_error: false,
                invaild_library_email_error: false,
                inavlid_end_time_error:false,
                invaild_library_primary_contact_email_error: false,
                invaild_website_url: false,
                city: "",
                state: "",
                country: "",
                zipcode: "",
                address_line1: "",
                address_line2: "",
                notes: "",
                zipcode_error:false
            });
        }
    };
    handleChangeApproval = (event) => {
        // console.log("FGDSHFGBHDFS"+JSON.stringify(event.target.value))
        this.setState({ interested_in_stem: event.target.value, interested_in_stem_error: false })
    };

    handleChangeRadio = (event) => {
        this.setState({ state_or_county: event.target.value });
    };
    validatePhone(phone) {
            var re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\\./0-9]*$/
            return re.test(phone);
    }
    handleClose = () => {
        this.setState({
            open: false,
            timeSlot: false,
            library_name: "",
            library_primary_contact_name: "",
            library_primary_contact_email: "",
            library_phone: "",
            library_email: "",
            selected_library_image_name: "",
            website_url: "",
            interested_in_stem: null,
            state_or_county: "",
            library_name_error: false,
            library_primary_contact_name_error: false,
            library_primary_contact_email_error: false,
            library_email_error: false,
            interested_in_stem_error: false,
            invaild_library_email_error: false,
            inavlid_end_time_error:false,
            invaild_library_primary_contact_email_error: false,
            invaild_website_url: false,
            city: "",
            state: "",
            country: "",
            zipcode: "",
            address_line1: "",
            address_line2: "",
            notes: "",
            start_time_error: false,
            end_time_error: false,
            day_of_week_error: false,
            start_time: null,
            end_time: null,
            day_of_week: '',
            status_error: false,
            status: "",
            zipcode_error:false
        });
    };

    validateEmail(email) {

        var re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    handleChange = (event, selectedTab) => {
        this.setState({ selectedTab });
    };

    bookingTimeSlot = (name, data) => {
        
        if (name !== "ADD") {
            let starttime = data.start_time !== null ? moment( data.start_time,'HH:mm:ss').format() : null;
            let endtime = data.end_time !== null ? moment( data.end_time,'HH:mm:ss').format() : null;
            // const  bookTime = this.props.bookingTimeSlot.filter(booking =>booking.id  === id );
            // if(bookTime.length > 0 ){
            this.setState({
                timeSlot: true,
                status: data.status,
                start_time: starttime,
                end_time: endtime,
                day_of_week: data.day_of_week,
                mode: "EDIT",
                id: data.id
            })

        } else {
            this.setState({
                timeSlot: true, mode: "ADD"
            })
        }

    };
    libraryImage = ({ target }) => {

        this.setState({ library_image: target.files[0], selected_library_image_name: target.files[0].name });
    };
    
    SubmitTimeSlot = () => {
        let starttime = this.state.start_time !== null ? moment( this.state.start_time).format('HH:mm:ss') : null;
        let endtime = this.state.end_time !== null ? moment( this.state.end_time).format('HH:mm:ss') : null;

        let isError = false;
        if (this.state.status !== "CLOSED") {
            if (this.state.start_time === "" || this.state.start_time === null ) {
                this.setState({ start_time_error: true })
                isError = true
            }

            if (this.state.end_time === "" || this.state.end_time === null ) {
                this.setState({ end_time_error: true })
                isError = true
            }
            if ((this.state.end_time < this.state.start_time)) {
                this.setState({ inavlid_end_time_error: true })
                isError = true
            }
        }

        if (this.state.status === "") {
            this.setState({ status_error: true })
            isError = true
        }

        if (this.state.day_of_week === "") {
            this.setState({ day_of_week_error: true })
            isError = true
        }

        if (isError === false) {
            // alert(JSON.stringify(this.state));
            if (this.state.mode === "ADD") {
                let bookingTimeSlots = {};
                bookingTimeSlots.start_time = starttime
                bookingTimeSlots.end_time = endtime
                bookingTimeSlots.library_id = this.state.library_id
                bookingTimeSlots.day_of_week = this.state.day_of_week
                bookingTimeSlots.status=this.state.status
                this.props.dispatch(bookingTimeSlot(this, bookingTimeSlots))
            } else {
                let updatebookingTimeSlot = {};
                updatebookingTimeSlot.start_time = starttime
                updatebookingTimeSlot.end_time = endtime
                updatebookingTimeSlot.library_id = this.state.library_id
                updatebookingTimeSlot.day_of_week = this.state.day_of_week
                updatebookingTimeSlot.status=this.state.status
                // const  bookTime = this.props.bookingTimeSlot.filter(booking =>booking.id  === this.state.id );
                this.props.dispatch(UpdateBookingTimeSlot(updatebookingTimeSlot, this.state.id));
            }
            this.setState({
                open: false,
                timeSlot: false,
                library_name: "",
                library_primary_contact_name: "",
                library_primary_contact_email: "",
                library_phone: "",
                library_email: "",
                website_url: "",
                interested_in_stem: null,
                state_or_county: "",
                library_name_error: false,
                selected_library_image_name: "",
                library_primary_contact_name_error: false,
                library_primary_contact_email_error: false,
                library_email_error: false,
                interested_in_stem_error: false,
                invaild_library_email_error: false,
                invaild_library_primary_contact_email_error: false,
                city: "",
                state: "",
                country: "",
                zipcode: "",
                address_line1: "",
                address_line2: "",
                notes: "",
                start_time_error: false,
                end_time_error: false,
                day_of_week_error: false,
                inavlid_end_time_error:false,
                start_time: null,
                end_time: null,
                day_of_week: '',
                status: "",
                status_error: false,
                mode: null,
                id: null
            })
        }
    };

    validateUrl(url) {
        var re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
        return re.test(url);
    }

    render() {
        const { classes, defaultRole } = this.props;
        // const words = this.props.myLibrary;
        const count = this.props.bookedTimes.filter(booked => booked.status === "REQUESTED");
        const data =  _.pluck(this.props.bookingTimeSlot,'day_of_week');
        const allday = _.difference(Day, data);
        // alert("++++++++"+this.state.start_time)
        return (
            <Grid container spacing={24} style={{paddingTop: 23}}>
                <Grid container spacing={8}>
                    {defaultRole === "THUNDERBOT" &&
                        <Grid item xs={12}>
                            <NewLibraryRequest bookings={this.props.bookedTimes} />
                        </Grid>
                    }
                    {defaultRole === "LIBRARIAN" &&
                        <Grid item xs={12}>
                            <Grid container spacing={8}>
                                <Grid item sm={3} xs={12}>
                                    {this.props.myLibrary.length > 0 ?
                                        this.props.myLibrary.map(library =>
                                            <Card className={classes.card}>
                                                <CardHeader
                                                    action={
                                                        <IconButton onClick={this.handleOpen}>
                                                            <FontAwesomeIcon icon="pencil-alt" style={{ fontSize: 15 }} />
                                                        </IconButton>
                                                    }
                                                    title={library.library_name}
                                                    subheader=""
                                                />
                                                <CardMedia
                                                    className={classes.media}
                                                    image={library.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${library.attachments[0].file_name}` : notfound}
                                                    title="Paella dish"
                                                />
                                                <CardContent>
                                                    <Typography gutterBottom style={{ marginBottom: 15 }}><Phone style={{ fontWeight:"bold",fontSize: 17 ,marginBottom:-3,marginLeft: -4 }}></Phone> {library.library_phone}</Typography>
                                                    <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                                        <FontAwesomeIcon icon="address-book" style={{ fontSize: 12, marginRight: 5 }} />  {library.library_email}
                                                    </Typography>
                                                    {/* <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                                        <FontAwesomeIcon icon="address-book" style={{ fontSize: 12, marginRight: 5 }} />  {(library.city !== "null" && library.city !== "" && library.city !== null) ? library.city : ""} {(library.state !== "null" && library.state !== "" && library.state !== null) ? "," + library.state : ""} {(library.country !== "null" && library.country !== "" && library.country !== null) ? "," + library.country : ""} {(library.zipcode !== "null" && library.zipcode !== "" && library.zipcode !== null) ? "," + library.zipcode : ""}
                                                    </Typography> */}
                                                    <div style={{ maxWidth: "200px" }}>
                                                    <Toolbar style={{padding:"0px"}}>
                                                    <FontAwesomeIcon icon="link" style={{ fontSize: 12, marginRight: 5  }} />
                                                        <Typography gutterBottom  style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                                                             <Link href={library.website_url} className={classes.link} > {library.website_url}</Link>
                                                        </Typography>
                                                        </Toolbar>
                                                    </div>


                                                </CardContent>
                                                <CardActions className={classes.actions} disableActionSpacing>

                                                </CardActions>
                                            </Card>
                                        ) : null}
                                </Grid>
                                <Grid item sm={9} xs={12} >
                                    <Grid item xs={12} >
                                        <Tabs
                                            value={this.state.selectedTab}
                                            onChange={this.handleChange}
                                            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                                        >
                                            <Tab
                                                disableRipple
                                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                icon={<FontAwesomeIcon icon="calendar" />}
                                            />
                                            <Tab
                                                disableRipple
                                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                label="Library Schedule"
                                            // icon={<FontAwesomeIcon icon="building"/>}
                                            />
                                            <Tab
                                                disableRipple
                                                classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
                                                label={<Badge style={{ right: -12 }} className={classes.margin} badgeContent={count.length} color="secondary">Booking Requests</Badge>}
                                            // icon={<FontAwesomeIcon icon="building"/>}
                                            />
                                        </Tabs>
                                        {this.state.selectedTab === 0 && <TabContainer><Calendar /></TabContainer>}
                                        {this.state.selectedTab === 1 &&
                                            <TabContainer>
                                                <div style={{ textAlign: "right", marginTop: -20 }}>
                                                   {this.props.bookingTimeSlot.length < 7 &&
                                                    <Button variant="contained" color="secondary" size="small" onClick={() => this.bookingTimeSlot("ADD")} className={classes.gradientButton}>
                                                        Add Booking time slot
                                                    </Button> }
                                                    
                                                </div>
                                                
                                                <Table className={classes.table}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <CustomTableCell align="center">Days</CustomTableCell>
                                                            <CustomTableCell align="center">Time</CustomTableCell>
                                                            <CustomTableCell align="center">Action</CustomTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.props.bookingTimeSlot.length > 0 ?
                                                            this.props.bookingTimeSlot.map(bookingTimeSlot =>
                                                                <TableRow className={classes.row} >
                                                                    <CustomTableCell component="th" scope="row" align="center">{bookingTimeSlot.day_of_week}</CustomTableCell>
                                                                    <CustomTableCell align="center">
                                                                        <Chip
                                                                            label={bookingTimeSlot.status === "ACTIVE" ? `${moment(bookingTimeSlot.start_time, "hh:mm:ss").format('LT')} - ${moment(bookingTimeSlot.end_time, "hh:mm:ss").format('LT')}` : "Closed"}
                                                                            style={{ color: bookingTimeSlot.status === "ACTIVE" ? "green" : "red", borderColor: bookingTimeSlot.status === "ACTIVE" ? "green" : "red", width: 156 }}
                                                                            variant="outlined"
                                                                        />
                                                                    </CustomTableCell>
                                                                    <CustomTableCell component="th" scope="row" align="center">
                                                                       
                                                                        <Button variant="contained" color="secondary" size="small" onClick={() => this.bookingTimeSlot("EDIT", bookingTimeSlot)} >
                                                                            Edit
                                                                        </Button>
                                                                    </CustomTableCell>

                                                                </TableRow>)
                                                            : null}
                                                    </TableBody>
                                                </Table>
                                                {/* </Card> */}

                                            </TabContainer>
                                        }
                                        {this.state.selectedTab === 2 &&
                                            <TabContainer>
                                                <div style={{overflowX: innerWidth < 480 && "scroll"  }}> 
                                                <Table  >
                                                    <TableHead >
                                                        <TableRow >
                                                            <CustomTableCell align="center">Team/Class</CustomTableCell>
                                                            <CustomTableCell align="center">Coach</CustomTableCell>
                                                            <CustomTableCell align="center">Date</CustomTableCell>
                                                            <CustomTableCell align="center">Time</CustomTableCell>
                                                            <CustomTableCell align="center">Action</CustomTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody >

                                                        {this.props.bookedTimes.length > 0 ?
                                                            this.props.bookedTimes.map(bookedTimes =>
                                                                bookedTimes.status === "REQUESTED" ?
                                                                    <TableRow className={classes.row} key={bookedTimes.id}>
                                                                        <CustomTableCell align="center" >{bookedTimes.team !== null ? bookedTimes.team.team_name : bookedTimes.class.class_name}</CustomTableCell>
                                                                        <CustomTableCell align="center">{bookedTimes.team !== null ? bookedTimes.team.user.first_name + " " : bookedTimes.class.user.first_name + " "}{bookedTimes.team !== null ? bookedTimes.team.user.last_name : bookedTimes.class.user.last_name + " "}</CustomTableCell>
                                                                        <CustomTableCell align="center">{moment(bookedTimes.date, 'YYYY-MM-DD').format("MM-DD-YYYY")}</CustomTableCell>
                                                                        <CustomTableCell align="Center">
                                                                            <Chip
                                                                                label={`${moment(bookedTimes.start_time).format('LT')} - ${moment(bookedTimes.end_time).format('LT')}`}
                                                                                style={{ color: bookedTimes.status === "REQUESTED" ? "orange" : "green", borderColor: bookedTimes.status === "REQUESTED" ? "orange" : "green", width: 156 }}
                                                                                variant="outlined"
                                                                            />
                                                                        </CustomTableCell>
                                                                        <CustomTableCell align="center">
                                                                                {/* <Toolbar> */}
                                                                                <Button variant="contained" size="small" color="primary" className={classes.button} onClick={() => { this.props.dispatch(teamBookingUpdate(bookedTimes.id, "ACTIVE")) }}>
                                                                                    Accept
                                                                                </Button>
                                                                                <Button variant="contained" size="small" color="secondary" className={classes.button} onClick={() => { this.props.dispatch(teamBookingUpdate(bookedTimes.id, "REJECTED")) }}>
                                                                                    Reject
                                                                                </Button>
                                                                                {/* </Toolbar> */}
                                                                        </CustomTableCell>
                                                                    </TableRow>
                                                                    : bookedTimes.status === "ACTIVE" ?
                                                                        <TableRow className={classes.row} key={bookedTimes.id}>
                                                                            <CustomTableCell align="center">{bookedTimes.team !== null ? bookedTimes.team.team_name : bookedTimes.class.class_name}</CustomTableCell>
                                                                            <CustomTableCell align="center">{bookedTimes.team !== null ? bookedTimes.team.user.first_name + " " : bookedTimes.class.user.first_name + " "}{bookedTimes.team !== null ? bookedTimes.team.user.last_name : bookedTimes.class.user.last_name + " "}</CustomTableCell>
                                                                            <CustomTableCell align="center">{moment(bookedTimes.date, 'YYYY-MM-DD').format("MM-DD-YYYY")}</CustomTableCell>
                                                                            <CustomTableCell align="center">
                                                                                <Chip
                                                                                    label={`${moment(bookedTimes.start_time).format('LT')} - ${moment(bookedTimes.end_time).format('LT')}`}
                                                                                    style={{ color: "green", borderColor: "green", width: 156 }}
                                                                                    variant="outlined"
                                                                                />
                                                                            </CustomTableCell>
                                                                            <CustomTableCell align="center">

                                                                                <Typography style={{ color: "green" }}>Accepted</Typography>
                                                                            </CustomTableCell>
                                                                        </TableRow> :

                                                                        null
                                                            ) : null}
                                                    </TableBody>
                                                </Table>
                                                </div>
                                            </TabContainer>
                                        }

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    }
                </Grid>

                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.papers}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" >
                            Edit Library
                        </Typography>
                        <div className={classes.withOverFlow}>
                        <Grid container spacing={8}>
                            <Grid item xs={12} style={{marginTop:15}}>
                                <FormLabel component="legend" required style={{  fontSize: "14px", color: 'black' }} error={this.state.interested_in_stem_error === true ? true : false}>
                                    Is the library interested in learning more about STEM learning exchange program ?
                                </FormLabel>
                                <RadioButtonGroup defaultValue={this.state.interested_in_stem} onChange={this.handleChangeApproval} row style={{ marginLeft: "10px" }}>
                                    <FormControlLabel value={this.state.interested_in_stem === true ? true : "Yes"} control={<RadioButton />} label="Yes" />
                                    <FormControlLabel value={this.state.interested_in_stem === false ? false : "No"} control={<RadioButton />} label="No" />
                                </RadioButtonGroup>
                                <FormHelperText error> {this.state.interested_in_stem_error === true ? "Please select Yes/No in interested STEM" : false} </FormHelperText>
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel component="legend" style={{  fontSize: "14px", color: 'black', marginBottom: 8 }}>
                                    If the library is a branch of state/county wide network state which one (e.g. Sacramento library )?
                                </FormLabel>
                                <TextField
                                    id="standard-name"
                                    // label="If the library is a branch of state/county wide network state which one (e.g. Sacramento library )?"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.state_or_county}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    // helperText={this.state.library_name_error === true ? "Please enter library name" : false}
                                    // error={this.state.library_name_error === true ? true : false}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ state_or_county: value })}
                                        
                                        }
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 3 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="Library name"
                                    required
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.library_name}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    helperText={this.state.library_name_error === true ? "Please enter library name" : false}
                                    error={this.state.library_name_error === true ? true : false}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ library_name: value, library_name_error: false })}
                                        }
                                />
                            </Grid>


                            <Grid item xs={innerWidth > 480 ? 3 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="Library phone"
                                    fullWidth
                                    // type="number"
                                    className={classes.textField}
                                    value={this.state.library_phone}
                                    onChange={(event) => this.setState({ library_phone: event.target.value,library_phone_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    helperText={this.state.library_phone_error === true ? "Please enter valid phone number" : false}
                                    error={this.state.library_phone_error === true ? true : false}
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 3 : 12} >
                                <TextField
                                    id="standard-name"
                                    label="Library mailing address"
                                    required
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.library_email}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    helperText={this.state.library_email_error === true ? "Please enter mailing address " : false}
                                    error={this.state.library_email_error === true ? true : false}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ library_email: value, library_email_error: false })}
                                        }
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 3 : 12} >
                                <TextField
                                    id="standard-name"
                                    label="Library website URL"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.website_url}
                                    onChange={(event) => this.setState({ website_url: event.target.value, invaild_website_url: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    error={this.state.invaild_website_url === true ? true : false}
                                    helperText={this.state.invaild_website_url === true ? "Please enter valid website url" : null}
                                />
                            </Grid>
                            {/* <Grid item xs={3} >
                                <TextField
                                    id="standard-name"
                                    label="Address line 1"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.address_line1}
                                    onChange={(event) => this.setState({ address_line1: event.target.value })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3} >
                                <TextField
                                    id="standard-name"
                                    label="Address line 2"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.address_line2}
                                    onChange={(event) => this.setState({ address_line2: event.target.value })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid> */}
                            {/* <Grid item xs={innerWidth > 480 ? 3 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="City"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.city || ''}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ city: value })}
                                        }
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 3 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="State"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.state}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ state: value })}
                                        }
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />

                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 3 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="Country"
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.country}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ country: value })}
                                        }
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 3 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="Zipcode"
                                    fullWidth
                                    // type="number"
                                    className={classes.textField}
                                    value={this.state.zipcode}
                                   // onChange={(event) => this.setState({ zipcode: event.target.value ,zipcode_error:false})}
                                   onChange={(event) => this.setState({ zipcode: event.target.value,zipcode_error: false })}
                                   margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                    helperText={this.state.zipcode_error === true ? "Please enter valid Zipcode " : false}
                                    error={this.state.zipcode_error === true ? true : false}
                                />
                            </Grid> */}
                            <Grid item xs={12} >
                                <TextField
                                    id="standard-name"
                                    label="Notes"
                                    fullWidth
                                    multiline
                                    rowsMax="4"
                                    className={classes.textField}
                                    value={this.state.notes}
                                    onChange={(event) => 
                                        {
                                            let value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)
                                            this.setState({ notes: value })}
                                        }
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                                {/* <ReactQuill value={this.state.notes} onChange={(value)=>{this.setState({ notes: value})}} style={{ height: "50px"}} /> */}

                            </Grid>
                            <Grid item xs={12} >

                                <input
                                    accept="image/*"
                                    className={classes.input}
                                    id="contained-button-file"
                                    type="file"
                                    onChange={this.libraryImage}
                                />
                                <label htmlFor="contained-button-file">
                                    <Button variant="outlined" component="span" className={classes.gradientButton}>
                                        update library image
                                    <CloudUploadIcon className={classes.rightIcon} />
                                    </Button>
                                </label>
                                <Typography>{this.state.selected_library_image_name}</Typography>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                        cancel
                                    </Button>
                                    <Button variant="contained" size="small" className={classes.button1} onClick={this.buttonchange}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                        </div>
                    </div>

                </Modal>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.timeSlot}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paperFortimeSlot}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        {this.state.mode !== "ADD" ? <Typography variant="h6" >
                            Edit time slot
                        </Typography> :
                        <Typography variant="h6" >
                            Add time slot
                        </Typography>}
                        <Grid container spacing={8} style={{ marginTop: 15 }}>
                            <Grid item xs={12}>
                                <form className={classes.root} autoComplete="off">
                                    <FormControl  fullWidth>
                                        <InputLabel required shrink htmlFor="age-simple" error={this.state.status_error === true ? true : false} >Status</InputLabel>
                                        <Select
                                            value={this.state.status}
                                            onChange={(event) => this.setState({ status: event.target.value, status_error: false })}
                                            // error={this.state.status_error === true ? true : false}
                                            inputProps={{
                                                name: 'age',
                                                id: 'age-simple',
                                            }}
                                        >
                                            <MenuItem value={"ACTIVE"}>Active</MenuItem>
                                            <MenuItem value={"CLOSED"}>Closed</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <FormHelperText id="component-helper-text" error>{this.state.status_error === true && "Please select status"}</FormHelperText>
                                </form>
                            </Grid>

                            <Grid item xs={6} >
                                {this.state.status !== "CLOSED" &&
                                    <TimePicker
                                        id="time"
                                        label="Start Time"
                                        // type="time"
                                        fullWidth
                                        required
                                        value={this.state.start_time}
                                        onChange={(time) =>{ 
                                            this.setState({start_time: time, start_time_error: false })
                                            }
                                        }
                                        className={classes.textFieldTime}
                                        helperText={this.state.start_time_error === true ? "Please enter start time" : false}
                                        error={this.state.start_time_error === true ? true : false}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            step: 300, // 5 min
                                        }}
                                    />
                                }
                            </Grid>
                            <Grid item xs={6} >
                                {this.state.status !== "CLOSED" &&
                                    <TimePicker
                                        id="time"
                                        label="End Time"
                                        // type="time"
                                        fullWidth
                                        required
                                        value={this.state.end_time}
                                        onChange={(time) => this.setState({ end_time: time, end_time_error: false, inavlid_end_time_error:false })}
                                        helperText={this.state.end_time_error === true ? "Please enter end time" : this.state.inavlid_end_time_error === true ? "Please enter valid end time" : false}
                                        error={this.state.end_time_error === true ? true : this.state.inavlid_end_time_error === true ? true : false}
                                        className={classes.textFieldTime}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            step: 300, // 5 min
                                        }}
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} >
                                {this.state.mode !== "EDIT" ?
                                    <form className={classes.root} autoComplete="off">
                                        <FormControl fullWidth>
                                            <InputLabel required shrink htmlFor="age-simple" error={this.state.day_of_week_error === true ? true : false} >Day of Week</InputLabel>
                                            <Select
                                                value={this.state.day_of_week}
                                                onChange={(event) => this.setState({ day_of_week: event.target.value, day_of_week_error: false })}
                                                error={this.state.day_of_week_error === true ? true : false}
                                                inputProps={{
                                                    name: 'age',
                                                    id: 'age-simple',
                                                }}
                                            >
                                                {allday.length > 0 && 

                                                allday.map(days => 

                                                <MenuItem value={days} key={days.id}>{days}</MenuItem>

                                                )}
                                                {/* <MenuItem value={"Monday"}>Monday</MenuItem>
                                                <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                                                <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                                                <MenuItem value={"Thursday"}>Thursday</MenuItem>
                                                <MenuItem value={"Friday"}>Friday</MenuItem>
                                                <MenuItem value={"Saturday"}>Saturday</MenuItem>
                                                <MenuItem value={"Sunday"}>Sunday</MenuItem> */}
                                            </Select>
                                        </FormControl>
                                        <FormHelperText id="component-helper-text" error>{this.state.day_of_week_error === true && "Please select day"}</FormHelperText>
                                    </form>
                                    : <form className={classes.root} autoComplete="off">
                                        <FormControl fullWidth>
                                            <InputLabel required shrink htmlFor="age-simple" error={this.state.day_of_week_error === true ? true : false} >Day of Week</InputLabel>
                                            <Select
                                                value={this.state.day_of_week}
                                                //onChange={(event) => this.setState({ day_of_week: event.target.value, day_of_week_error: false })}
                                                // helperText={this.state.day_of_week_error === true ? "Please enter end time" : false}
                                                error={this.state.day_of_week_error === true ? true : false}
                                                inputProps={{
                                                    name: 'age',
                                                    id: 'age-simple',
                                                }}
                                            >
                                                <MenuItem value={this.state.day_of_week}>{this.state.day_of_week}</MenuItem>
                                                {/* <MenuItem value={"Tuesday"}>Tuesday</MenuItem>
                                        <MenuItem value={"Wednesday"}>Wednesday</MenuItem>
                                        <MenuItem value={"Thursday"}>Thursday</MenuItem>
                                        <MenuItem value={"Friday"}>Friday</MenuItem>
                                        <MenuItem value={"Saturday"}>Saturday</MenuItem>
                                        <MenuItem value={"Sunday"}>Sunday</MenuItem> */}
                                            </Select>
                                        </FormControl>
                                        <FormHelperText id="component-helper-text" error>{this.state.day_of_week_error === true && "Please select day"}</FormHelperText>
                                    </form>}
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button variant="contained" color="secondary" size="small" className={classes.cancelbutton} onClick={this.handleClose}>
                                        cancel
                                    </Button>
                                    <Button variant="contained" size="small" className={classes.button1} onClick={this.SubmitTimeSlot}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>

                </Modal>
            </Grid>
        );
    }
}

Library.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        myLibrary: state.LibraryReducer.myLibrary,
        user: state.SessionReducer.user,
        defaultRole: state.SessionReducer.defaultRole,
        bookingTimeSlot: state.BookingTimeSlotReducer.bookingTimeSlot,
        bookedTimes: state.BookedReducer.bookedTimes
    }
}
export default compose(withStyles(styles), connect(mapStateToProps))(Library);

